module.exports = __webpack_public_path__ + "static/media/cloud_2.87983021.png";